import colors from '../foundation/colors';

const Drawer = {
  parts: ['dialog', 'header', 'body'],
  baseStyle: {
    header: {
      color: colors.greyScale['900'],
      textStyle: 'displayXxs',
      py: 6
    },
    body: {
      px: 6
    }
  },
  variants: {
    primary: {
      dialog: {
        background: 'white',
        color: colors.greyScale['500']
      }
    },
    secondary: {
      dialog: {
        background: colors.backgroundScale['50'],
        color: colors.greyScale['900']
      }
    }
  },
  sizes: {
    '2xl': { dialog: { maxH: '100%', maxW: '70%' } },
    '3xl': { dialog: { maxH: '100%', maxW: '80%' } },
    '4xl': { dialog: { maxH: '100%', maxW: '90%' } }
  }
};

export default Drawer;
